module.exports = __webpack_public_path__ + "img/icn_email.681d9456.svg";